'use client';

import React, { useState } from "react";

const Image = ({
  src,
  fallbackSrc,
  className = "",
  alt = "",
  imgClassName = "",
  fit = "cover",
  ...props
}) => {
  const [loading, setLoading] = useState(true);
  const [srcError, setSrcError] = useState(false);
  const [fallbackError, setFallbackError] = useState(false);

  const currentSrc = srcError
    ? fallbackError
      ? null
      : fallbackSrc
    : src || fallbackSrc;

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Loading Shimmer */}
      {loading && !srcError && !fallbackError && (
        <div className="absolute inset-0 bg-zinc-800 rounded overflow-hidden">
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
        </div>
      )}

      {currentSrc ? (
        <img
          src={currentSrc}
          alt={alt}
          className={`${imgClassName} w-full h-full transition-opacity ${
            loading ? "opacity-0" : "opacity-100"
          }`}
          style={{ objectFit: fit }}
          onLoad={() => setLoading(false)}
          onError={() => {
            if (!srcError) {
              setSrcError(true);
            } else {
              setFallbackError(true);
            }
            setLoading(false);
          }}
          {...props}
        />
      ) : (
        <div className="absolute inset-0 bg-color-95 rounded-lg border border-color-97"></div>
      )}
    </div>
  );
};

export default Image;
